import { CUSTOM_MODEL_STATUS } from 'src/data/customModel';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { ProjectStore, useBrandVoicesAssets } from 'src/store';

const useProjectState = createStateSelectorHook(ProjectStore, [
  'selectedTov',
  'selectedCustomModelId',
  'draftToneOfVoice',
  'toneOfVoiceMenuOpened',
  'toneOfVoiceError',
]);

export const useViewState = () => {
  const { customModels, toneOfVoices } = useBrandVoicesAssets();
  const {
    selectedTov,
    selectedCustomModelId,
    draftToneOfVoice,
    toneOfVoiceMenuOpened,
    toneOfVoiceError,
  } = useProjectState();

  const filteredCustomModels = customModels.filter(
    (customModel) => customModel.status === CUSTOM_MODEL_STATUS.active
  );

  return {
    toneOfVoices,
    customModels: filteredCustomModels,
    selectedTov,
    selectedCustomModelId,
    draftToneOfVoice,
    toneOfVoiceMenuOpened,
    toneOfVoiceError,
  };
};
